import map from 'lodash/map';
import without from 'lodash/without';

import React from 'react';
import PropTypes from 'prop-types';
import { change } from 'redux-form';
import { connect } from 'react-redux';

import {
  getVisibleSelectedParametersNames,
  getVisibleNumericalSelectedParametersNames
} from 'store/dataset';

import ParameterDropdownComponent from './Component';

class ParameterDropdownContainer extends React.PureComponent {
  constructor (props) {
    super(props);

    this.handleChange = (_, newValue, previousValue) => {
      if (newValue !== previousValue) {
        // Resets selected parameter level dropdown option
        this.props.change(this.props.form, 'parameterLevel', '');
        this.props.change(this.props.form, 'primaryParameterLevel', '');

        if (this.props.onChange) {
          this.props.onChange(newValue, previousValue);
        }

        if (this.props.resetSecondaryParameter) {
          this.props.change(this.props.form, 'secondaryParameter', '');
        }
      }
    };
  }

  get options () {
    const { primaryParameterName, parametersNames } = this.props;

    return map(without(parametersNames, primaryParameterName),
      parameterName => ({ value: parameterName, text: parameterName })
    );
  }

  render () {
    /* eslint-disable */

    const {
      resetSecondaryParameter,
      primaryParameterName,
      parametersNames,
      onlyNumerical,
      change,

      ...props
    } = this.props

    /* eslint-enable */

    return (
      <ParameterDropdownComponent
        {...props}
        options={this.options}
        onChange={this.handleChange}
      />
    );
  }
}

ParameterDropdownContainer.propTypes = {
  parametersNames: PropTypes.array.isRequired,
  primaryParameterName: PropTypes.string,

  resetSecondaryParameter: PropTypes.bool,

  change: PropTypes.func.isRequired,
  form: PropTypes.string.isRequired,

  onChange: PropTypes.func,
  label: PropTypes.string,
  name: PropTypes.string
};

ParameterDropdownContainer.defaultProps = {
  onChange: null,
  name: 'parameter',
  label: 'Variable 1',

  primaryParameterName: '',
  resetSecondaryParameter: false
};

const mapStateToProps = (state, props) => ({
  parametersNames:
    props.onlyNumerical
      ? getVisibleNumericalSelectedParametersNames(state)
      : getVisibleSelectedParametersNames(state)
});

const mapDispatchToProps = {
  change
};

export default connect(mapStateToProps, mapDispatchToProps)(
  ParameterDropdownContainer
);
